<template>
  <article class="info-section">
    <div class="page-section">
      <div class="info-section-header">
        <h1 class="info-section-heading">Contact</h1>
      </div>
      <p>MyLittlePonyCollection is a resource for MLP collectors and admirers. Collectors can organize and track their collections, wishlists and favorite ponies. You can also browse through the many different generations of ponies.</p>
      <p>Search by color, mold, country and more.</p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style>
.page-section {
  max-width: 768px;
  margin: auto;
}
</style>

